<template>
  <v-container fluid v-if="story != null">
    <v-layout row wrap>
      <story-edit-fields v-model="story" type="add"></story-edit-fields>
    </v-layout>
  </v-container>
</template>

<script>
import StoryEditFields from '@/components/StoryEditFields.vue';

export default {
  name: 'StoryAddView',
  components: { StoryEditFields },
  computed: {
    story: {
      get() {
        return {
        };
      },
      set(value) {
        this.$store.commit('createStory', value);
        this.$router.push({ name: 'Stories' });
      },
    },
  },
};
</script>
